<template>
  <Navbar :center-text="$t('PasswordResetView.passwordReset')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container container-login mt-5 d-flex justify-content-center align-items-center">
    <form @submit.prevent="handleReset"
          class="form-horizontal w-100">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-6 form-group mb-4">
        <label for="email"
               class="form-label">
          {{ $t('email') }}
        </label>
        <input v-model="email"
               type="text"
               class="form-control rounded-pill"
               id="email"
               :placeholder="$t('enterEmail')"
               required />
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-6 form-group mb-4">
          <button type="submit"
                  class="btn btn-success rounded-pill mb-4 w-100"
                  v-if="showResetButton">
            <i class="bi bi-arrow-counterclockwise"></i>
            {{ $t('PasswordResetView.passwordReset') }}
          </button>
          <button type="button"
                  class="btn btn-primary rounded-pill mb-4 w-100"
                  v-if="!showResetButton"
                  @click="goToLogin">
            <i class="bi bi-person-fill"></i>
            {{ $t('goToLogin')}}
          </button>
        </div>
      </div>
    </div>
    </form>
  </div>
  <Footerbar></Footerbar>
</template>

<script>

import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import {postReset} from "@/utils";

export default {
  data() {
    return {
      email: "",
      showResetButton: true,
      messageType: "info",
      message: this.$t('PasswordResetView.passwordResetInfo'),
    }
  },
  components: {
    Footerbar,
    Navbar
  },
  methods: {
    async handleReset() {
      let response = await postReset(this.email);
      if(response.status !== null){
        // Always give out a success message, so a potential attacker can not determine whether an email is registered or not.
        this.message = this.$t('PasswordResetView.passwordResetSuccess');
        this.messageType = "success";
        this.showResetButton = false;
      }
    },
    goToLogin() {
      this.$router.push({
        name: "root",
      });
    },
  }
}
</script>